import { create } from 'zustand';

const useSocketStore = create((set, get) => ({
  socket: null,
  isConnected: false,
  connectionError: null,
  reconnectAttempts: 0,

  setSocket: (socket) => set({ socket }),

  setConnected: (isConnected) => set({ isConnected }),

  setConnectionError: (error) => set({ connectionError: error }),

  incrementReconnectAttempts: () => set((state) => ({
    reconnectAttempts: state.reconnectAttempts + 1
  })),

  resetReconnectAttempts: () => set({ reconnectAttempts: 0 }),

  emit: (event, data) => {
    const { socket, isConnected } = get();
    if (socket && isConnected) {
      socket.emit(event, data);
      return true;
    }
    console.warn('Socket not connected, cannot emit:', event);
    return false;
  },

  on: (event, callback) => {
    const { socket } = get();
    if (socket) {
      socket.on(event, callback);
    }
  },

  off: (event, callback) => {
    const { socket } = get();
    if (socket) {
      socket.off(event, callback);
    }
  },

  disconnect: () => {
    const { socket } = get();
    if (socket) {
      socket.disconnect();
      set({ socket: null, isConnected: false });
    }
  },

  reset: () => set({
    socket: null,
    isConnected: false,
    connectionError: null,
    reconnectAttempts: 0
  }),
}));

export default useSocketStore;
